const COLOR_PRIMARY = '#00AD6B';
const COLOR_SECONDARY = '#000034';
const DISABLED_BACKGROUND_COLOR = '#d8d8d8';
const BORDER_RADIUS = 3;

export default {
  a: {
    color: COLOR_PRIMARY,
  },
  container: {
    flex: 1,
  },
  section: {
    flex: 1,
    width: '100%',
    padding: 18,
  },
  sectionHeader: {
    width: '100%',
    marginBottom: 24,
  },
  sectionHeaderText: {
    color: COLOR_SECONDARY,
    fontSize: 16,
    fontWeight: '500',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  sectionFooter: {
    justifyContent: 'space-evenly',
  },
  sectionFooterLink: {
    fontSize: 14,
    color: COLOR_PRIMARY,
    alignItems: 'baseline',
    textAlign: 'center',
    a: {
      color: COLOR_SECONDARY,
    },
  },
  navBar: {
    marginTop: 35,
    padding: 15,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  navButton: {
    marginLeft: 12,
    borderRadius: 4,
  },
  cell: {
    flex: 1,
    width: '50%',
  },
  errorRow: {
    flexDirection: 'row',
    justifyContent: 'center',
  },
  errorRowText: {
    marginLeft: 10,
  },
  photo: {
    width: '100%',
  },
  album: {
    width: '100%',
  },
  button: {
    backgroundColor: COLOR_PRIMARY,
    alignItems: 'center',
    borderRadius: BORDER_RADIUS,
  },
  buttonDisabled: {
    backgroundColor: DISABLED_BACKGROUND_COLOR,
    opacity: 1,
    alignItems: 'center',
    padding: 16,
    borderRadius: BORDER_RADIUS,
  },
  buttonText: {
    color: '#fff',
    fontSize: 14,
    fontWeight: '600',
  },
  formField: {
    marginBottom: 22,
  },
  input: {
    padding: 16,
    borderWidth: 1,
    borderRadius: 3,
    borderColor: '#C4C4C4',
  },
  inputLabel: {
    marginBottom: 8,
  },
  socialSignInButton: {
    border: 0,
    background: 'transparent',
    cursor: 'pointer',
  },
};
